import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_sentryserver_508a4a1f from 'nuxt_plugin_sentryserver_508a4a1f' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_2a5e4ed2 from 'nuxt_plugin_sentryclient_2a5e4ed2' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_NuxtSeo_5f74feac from 'nuxt_plugin_NuxtSeo_5f74feac' // Source: ./Nuxt-Seo.js (mode: 'all')
import nuxt_plugin_plugin_45f23bed from 'nuxt_plugin_plugin_45f23bed' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_vue2editor_5cdd2063 from 'nuxt_plugin_vue2editor_5cdd2063' // Source: ./vue2-editor.js (mode: 'client')
import nuxt_plugin_apollomodule_7a5b5627 from 'nuxt_plugin_apollomodule_7a5b5627' // Source: ./apollo-module.js (mode: 'all')
import nuxt_plugin_nuxtvuexroutersync_86896f7a from 'nuxt_plugin_nuxtvuexroutersync_86896f7a' // Source: ./nuxt-vuex-router-sync.js (mode: 'all')
import nuxt_plugin_deviceplugin_72b021e6 from 'nuxt_plugin_deviceplugin_72b021e6' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_5988c1fa from 'nuxt_plugin_cookieuniversalnuxt_5988c1fa' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_axios_56aa155b from 'nuxt_plugin_axios_56aa155b' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_googleanalytics_5d93ebeb from 'nuxt_plugin_googleanalytics_5d93ebeb' // Source: ./google-analytics.js (mode: 'client')
import nuxt_plugin_image_41b11256 from 'nuxt_plugin_image_41b11256' // Source: ./image.js (mode: 'all')
import nuxt_plugin_fontLoader_c0a4d3ca from 'nuxt_plugin_fontLoader_c0a4d3ca' // Source: ./fontLoader.js (mode: 'client')
import nuxt_plugin_pluginserver_00c095fe from 'nuxt_plugin_pluginserver_00c095fe' // Source: ./color-mode/plugin.server.js (mode: 'server')
import nuxt_plugin_pluginclient_cc33790e from 'nuxt_plugin_pluginclient_cc33790e' // Source: ./color-mode/plugin.client.js (mode: 'client')
import nuxt_plugin_sentry_3c12fa56 from 'nuxt_plugin_sentry_3c12fa56' // Source: ../plugins/sentry (mode: 'all')
import nuxt_plugin_polyfills_7dce8c4e from 'nuxt_plugin_polyfills_7dce8c4e' // Source: ../plugins/polyfills (mode: 'all')
import nuxt_plugin_extendnuxtapp_5bc53118 from 'nuxt_plugin_extendnuxtapp_5bc53118' // Source: ../plugins/extend-nuxt-app (mode: 'all')
import nuxt_plugin_modal_4f7cf3d0 from 'nuxt_plugin_modal_4f7cf3d0' // Source: ../plugins/modal (mode: 'all')
import nuxt_plugin_portal_4532993c from 'nuxt_plugin_portal_4532993c' // Source: ../plugins/portal (mode: 'all')
import nuxt_plugin_notice_4c047c64 from 'nuxt_plugin_notice_4c047c64' // Source: ../plugins/notice (mode: 'all')
import nuxt_plugin_axios_bbd72732 from 'nuxt_plugin_axios_bbd72732' // Source: ../plugins/axios/axios (mode: 'all')
import nuxt_plugin_filters_98405076 from 'nuxt_plugin_filters_98405076' // Source: ../plugins/filters (mode: 'all')
import nuxt_plugin_breakpoint_4655f928 from 'nuxt_plugin_breakpoint_4655f928' // Source: ../plugins/breakpoint (mode: 'all')
import nuxt_plugin_transitions_4f4e7c88 from 'nuxt_plugin_transitions_4f4e7c88' // Source: ../plugins/transitions (mode: 'all')
import nuxt_plugin_bravadotooltip_d05518d6 from 'nuxt_plugin_bravadotooltip_d05518d6' // Source: ../plugins/bravado_tooltip (mode: 'all')
import nuxt_plugin_globalcomponents_68527f08 from 'nuxt_plugin_globalcomponents_68527f08' // Source: ../plugins/global_components (mode: 'all')
import nuxt_plugin_signuppopupwithdelay_2fd6efd5 from 'nuxt_plugin_signuppopupwithdelay_2fd6efd5' // Source: ../plugins/sign-up-popup-with-delay (mode: 'client')
import nuxt_plugin_gtag_6a810249 from 'nuxt_plugin_gtag_6a810249' // Source: ../plugins/gtag (mode: 'client')
import nuxt_plugin_3rdparty_3ee029b2 from 'nuxt_plugin_3rdparty_3ee029b2' // Source: ../plugins/3rd-party (mode: 'client')
import nuxt_plugin_analytics_0ae804d0 from 'nuxt_plugin_analytics_0ae804d0' // Source: ../plugins/analytics (mode: 'client')
import nuxt_plugin_analyticslogger_f98c56bc from 'nuxt_plugin_analyticslogger_f98c56bc' // Source: ../plugins/analytics-logger (mode: 'client')
import nuxt_plugin_scrolllog_e3576a70 from 'nuxt_plugin_scrolllog_e3576a70' // Source: ../plugins/scroll_log (mode: 'client')
import nuxt_plugin_logpageview_b76c4138 from 'nuxt_plugin_logpageview_b76c4138' // Source: ../plugins/log_page_view (mode: 'client')
import nuxt_plugin_tooltip_ba49f866 from 'nuxt_plugin_tooltip_ba49f866' // Source: ../plugins/tooltip (mode: 'client')
import nuxt_plugin_vue2touchevents_0aa7791c from 'nuxt_plugin_vue2touchevents_0aa7791c' // Source: ../plugins/vue2-touch-events (mode: 'client')
import nuxt_plugin_viewport_3a6b3e1c from 'nuxt_plugin_viewport_3a6b3e1c' // Source: ../plugins/viewport (mode: 'client')
import nuxt_plugin_logtransitionintowrmember_f3350dd0 from 'nuxt_plugin_logtransitionintowrmember_f3350dd0' // Source: ../plugins/log-transition-into-wr-member (mode: 'client')
import nuxt_plugin_vclickoutside_661f0b13 from 'nuxt_plugin_vclickoutside_661f0b13' // Source: ../plugins/v-click-outside (mode: 'client')
import nuxt_plugin_utils_3336a20a from 'nuxt_plugin_utils_3336a20a' // Source: ../plugins/utils (mode: 'all')
import nuxt_plugin_globalconstants_33fbe1ae from 'nuxt_plugin_globalconstants_33fbe1ae' // Source: ../plugins/global_constants (mode: 'all')
import nuxt_plugin_401redirect_7693861c from 'nuxt_plugin_401redirect_7693861c' // Source: ../plugins/401_redirect (mode: 'all')
import nuxt_plugin_cypress_30b22557 from 'nuxt_plugin_cypress_30b22557' // Source: ../plugins/cypress (mode: 'all')
import nuxt_plugin_cancelablenotice_628ef426 from 'nuxt_plugin_cancelablenotice_628ef426' // Source: ../plugins/cancelable_notice (mode: 'all')
import nuxt_plugin_confirm_1f801a8a from 'nuxt_plugin_confirm_1f801a8a' // Source: ../plugins/confirm (mode: 'all')
import nuxt_plugin_pages_33d4e3e4 from 'nuxt_plugin_pages_33d4e3e4' // Source: ../plugins/pages (mode: 'all')
import nuxt_plugin_calendly_2f137be0 from 'nuxt_plugin_calendly_2f137be0' // Source: ../plugins/calendly (mode: 'client')
import nuxt_plugin_bravadonav_55292b27 from 'nuxt_plugin_bravadonav_55292b27' // Source: ../plugins/bravado-nav (mode: 'all')
import nuxt_plugin_auth_03780716 from 'nuxt_plugin_auth_03780716' // Source: ./auth.js (mode: 'all')
import nuxt_plugin_auth_6a7e4e1e from 'nuxt_plugin_auth_6a7e4e1e' // Source: ../plugins/auth (mode: 'all')
import nuxt_plugin_meta_11222e3f from 'nuxt_plugin_meta_11222e3f' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"meta":[{"name":"viewport","hid":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1, viewport-fit=cover"},{"name":"google-site-verification","hid":"google","content":"51yg69067XmlVMb-HSJTa2SmLt0G71R7keH9-sV5A_4"},{"hid":"charset","charset":"utf-8"},{"hid":"lang","lang":"en"},{"hid":"language","language":"English"},{"hid":"description","key":"description","property":"description","name":"description","content":"Bravado is a community for the world’s top sales professionals. Join the War Room today to become the best with the best"},{"hid":"og:title","key":"og:title","property":"og:title","name":"og:title","content":"Join Bravado - The World’s Largest Sales Network"},{"hid":"og:description","key":"og:description","property":"og:description","name":"og:description","content":"Bravado is a community for the world’s top sales professionals. Join the War Room today to become the best with the best"},{"hid":"og:locale","key":"og:locale","property":"og:locale","name":"og:locale","content":"en"},{"hid":"og:type","key":"og:type","property":"og:type","name":"og:type","content":"website"},{"hid":"og:image","key":"og:image","property":"og:image","name":"og:image","content":"https:\u002F\u002Fbravado-static.s3-us-west-1.amazonaws.com\u002Fog_images\u002Fdefault_seo.png"},{"hid":"fb:app_id","key":"fb:app_id","property":"fb:app_id","name":"fb:app_id","content":"526703391488301"}],"link":[{"hid":"canonical","rel":"canonical","href":"\u002F"},{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"hid":"font-prefetch","rel":"dns-prefetch","href":"https:\u002F\u002Ffonts.gstatic.com\u002F"},{"hid":"font-preconnect","rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com\u002F","crossorigin":""},{"hid":"font-preload","rel":"preload","as":"style","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Inter:wght@400;500;600&display=swap"}],"htmlAttrs":{"lang":"en"},"script":[{"hid":"gdpr","src":"https:\u002F\u002Fcdn.cookielaw.org\u002Fscripttemplates\u002FotSDKStub.js","async":true,"data-language":"en","data-domain-script":"161d3426-168b-4768-afd0-b0a779373e27"}],"bodyAttrs":{"class":"body"},"style":[],"title":"Join Bravado - The World’s Largest Sales Network"},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.server && typeof nuxt_plugin_sentryserver_508a4a1f === 'function') {
    await nuxt_plugin_sentryserver_508a4a1f(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_2a5e4ed2 === 'function') {
    await nuxt_plugin_sentryclient_2a5e4ed2(app.context, inject)
  }

  if (typeof nuxt_plugin_NuxtSeo_5f74feac === 'function') {
    await nuxt_plugin_NuxtSeo_5f74feac(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_45f23bed === 'function') {
    await nuxt_plugin_plugin_45f23bed(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vue2editor_5cdd2063 === 'function') {
    await nuxt_plugin_vue2editor_5cdd2063(app.context, inject)
  }

  if (typeof nuxt_plugin_apollomodule_7a5b5627 === 'function') {
    await nuxt_plugin_apollomodule_7a5b5627(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtvuexroutersync_86896f7a === 'function') {
    await nuxt_plugin_nuxtvuexroutersync_86896f7a(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_72b021e6 === 'function') {
    await nuxt_plugin_deviceplugin_72b021e6(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_5988c1fa === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_5988c1fa(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_56aa155b === 'function') {
    await nuxt_plugin_axios_56aa155b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googleanalytics_5d93ebeb === 'function') {
    await nuxt_plugin_googleanalytics_5d93ebeb(app.context, inject)
  }

  if (typeof nuxt_plugin_image_41b11256 === 'function') {
    await nuxt_plugin_image_41b11256(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_fontLoader_c0a4d3ca === 'function') {
    await nuxt_plugin_fontLoader_c0a4d3ca(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_pluginserver_00c095fe === 'function') {
    await nuxt_plugin_pluginserver_00c095fe(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginclient_cc33790e === 'function') {
    await nuxt_plugin_pluginclient_cc33790e(app.context, inject)
  }

  if (typeof nuxt_plugin_sentry_3c12fa56 === 'function') {
    await nuxt_plugin_sentry_3c12fa56(app.context, inject)
  }

  if (typeof nuxt_plugin_polyfills_7dce8c4e === 'function') {
    await nuxt_plugin_polyfills_7dce8c4e(app.context, inject)
  }

  if (typeof nuxt_plugin_extendnuxtapp_5bc53118 === 'function') {
    await nuxt_plugin_extendnuxtapp_5bc53118(app.context, inject)
  }

  if (typeof nuxt_plugin_modal_4f7cf3d0 === 'function') {
    await nuxt_plugin_modal_4f7cf3d0(app.context, inject)
  }

  if (typeof nuxt_plugin_portal_4532993c === 'function') {
    await nuxt_plugin_portal_4532993c(app.context, inject)
  }

  if (typeof nuxt_plugin_notice_4c047c64 === 'function') {
    await nuxt_plugin_notice_4c047c64(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_bbd72732 === 'function') {
    await nuxt_plugin_axios_bbd72732(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_98405076 === 'function') {
    await nuxt_plugin_filters_98405076(app.context, inject)
  }

  if (typeof nuxt_plugin_breakpoint_4655f928 === 'function') {
    await nuxt_plugin_breakpoint_4655f928(app.context, inject)
  }

  if (typeof nuxt_plugin_transitions_4f4e7c88 === 'function') {
    await nuxt_plugin_transitions_4f4e7c88(app.context, inject)
  }

  if (typeof nuxt_plugin_bravadotooltip_d05518d6 === 'function') {
    await nuxt_plugin_bravadotooltip_d05518d6(app.context, inject)
  }

  if (typeof nuxt_plugin_globalcomponents_68527f08 === 'function') {
    await nuxt_plugin_globalcomponents_68527f08(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_signuppopupwithdelay_2fd6efd5 === 'function') {
    await nuxt_plugin_signuppopupwithdelay_2fd6efd5(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtag_6a810249 === 'function') {
    await nuxt_plugin_gtag_6a810249(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_3rdparty_3ee029b2 === 'function') {
    await nuxt_plugin_3rdparty_3ee029b2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_analytics_0ae804d0 === 'function') {
    await nuxt_plugin_analytics_0ae804d0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_analyticslogger_f98c56bc === 'function') {
    await nuxt_plugin_analyticslogger_f98c56bc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_scrolllog_e3576a70 === 'function') {
    await nuxt_plugin_scrolllog_e3576a70(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_logpageview_b76c4138 === 'function') {
    await nuxt_plugin_logpageview_b76c4138(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_tooltip_ba49f866 === 'function') {
    await nuxt_plugin_tooltip_ba49f866(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vue2touchevents_0aa7791c === 'function') {
    await nuxt_plugin_vue2touchevents_0aa7791c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_viewport_3a6b3e1c === 'function') {
    await nuxt_plugin_viewport_3a6b3e1c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_logtransitionintowrmember_f3350dd0 === 'function') {
    await nuxt_plugin_logtransitionintowrmember_f3350dd0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vclickoutside_661f0b13 === 'function') {
    await nuxt_plugin_vclickoutside_661f0b13(app.context, inject)
  }

  if (typeof nuxt_plugin_utils_3336a20a === 'function') {
    await nuxt_plugin_utils_3336a20a(app.context, inject)
  }

  if (typeof nuxt_plugin_globalconstants_33fbe1ae === 'function') {
    await nuxt_plugin_globalconstants_33fbe1ae(app.context, inject)
  }

  if (typeof nuxt_plugin_401redirect_7693861c === 'function') {
    await nuxt_plugin_401redirect_7693861c(app.context, inject)
  }

  if (typeof nuxt_plugin_cypress_30b22557 === 'function') {
    await nuxt_plugin_cypress_30b22557(app.context, inject)
  }

  if (typeof nuxt_plugin_cancelablenotice_628ef426 === 'function') {
    await nuxt_plugin_cancelablenotice_628ef426(app.context, inject)
  }

  if (typeof nuxt_plugin_confirm_1f801a8a === 'function') {
    await nuxt_plugin_confirm_1f801a8a(app.context, inject)
  }

  if (typeof nuxt_plugin_pages_33d4e3e4 === 'function') {
    await nuxt_plugin_pages_33d4e3e4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_calendly_2f137be0 === 'function') {
    await nuxt_plugin_calendly_2f137be0(app.context, inject)
  }

  if (typeof nuxt_plugin_bravadonav_55292b27 === 'function') {
    await nuxt_plugin_bravadonav_55292b27(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_03780716 === 'function') {
    await nuxt_plugin_auth_03780716(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_6a7e4e1e === 'function') {
    await nuxt_plugin_auth_6a7e4e1e(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_11222e3f === 'function') {
    await nuxt_plugin_meta_11222e3f(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
